/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { countryCodes } from '@/constants/locale';
import type { Locale } from '@/types/i18n';

export const formatPhoneNumber = (
  phoneNumber: string | undefined,
  locale?: Locale,
  { stripCountryCode = false }: { stripCountryCode?: boolean } = {},
): string => {
  if (!phoneNumber) {
    return '';
  }

  let normalizedPhone = phoneNumber;

  if (stripCountryCode && phoneNumber.startsWith('+')) {
    if (locale === countryCodes.ptBr) {
      normalizedPhone = phoneNumber.replace(/^\+55/, '');
    } else if (locale === countryCodes.mx) {
      normalizedPhone = phoneNumber.replace(/^\+52/, '');
    } else {
      normalizedPhone = phoneNumber.replace(/^\+1/, '');
    }
  }
  if (locale === countryCodes.ptBr) {
    const enddigits = normalizedPhone.slice(2);
    const startDigits = normalizedPhone.slice(0, 2);
    const firstGroupEnd = enddigits.length === 9 ? 5 : 4;
    return `(${startDigits}) ${enddigits.slice(0, firstGroupEnd)}-${enddigits.slice(
      firstGroupEnd,
    )}`;
  }

  const enddigits = normalizedPhone.slice(3);
  const startDigits = normalizedPhone.slice(0, 3);
  return `(${startDigits}) ${enddigits.slice(0, 3)}-${enddigits.slice(3)}`;
};
